export default [
    {
        key: 'borders',
        path: '/borders',
        name: 'borders',
        component: () => import(/* webpackChunkName: "borders" */ '@/modules/documentation/pages/borders.vue')
    },
    {
        key: 'box-loader',
        path: '/box-loader',
        name: 'box-loader',
        component: () => import(/* webpackChunkName: "box-loader" */ '@/modules/documentation/pages/box-loader.vue')
    },
    {
        key: 'breadcrumbs',
        path: '/breadcrumbs',
        name: 'breadcrumbs',
        component: () => import(/* webpackChunkName: "breadcrumbs" */ '@/modules/documentation/pages/breadcrumbs.vue')
    },
    {
        key: 'buttons',
        path: '/buttons',
        name: 'buttons',
        component: () => import(/* webpackChunkName: "buttons" */ '@/modules/documentation/pages/buttons.vue')
    },
    {
        key: 'hints',
        path: '/hints',
        name: 'hints',
        component: () => import(/* webpackChunkName: "hints" */ '@/modules/documentation/pages/hints.vue')
    },
    {
        key: 'jewel',
        path: '/jewel',
        name: 'jewel',
        component: () => import(/* webpackChunkName: "jewel" */ '@/modules/documentation/pages/jewel.vue')
    },
    {
        key: 'lists',
        path: '/lists',
        name: 'lists',
        component: () => import(/* webpackChunkName: "lists" */ '@/modules/documentation/pages/lists.vue')
    },
    {
        key: 'marker',
        path: '/marker',
        name: 'marker',
        component: () => import(/* webpackChunkName: "borders" */ '@/modules/documentation/pages/marker.vue')
    },
    {
        key: 'sort',
        path: '/sort',
        name: 'sort',
        component: () => import(/* webpackChunkName: "sort" */ '@/modules/documentation/pages/sort.vue')
    },
    {
        key: 'tabs',
        path: '/tabs',
        name: 'tabs',
        component: () => import(/* webpackChunkName: "tabs" */ '@/modules/documentation/pages/tabs.vue')
    },
    {
        key: 'tooltips',
        path: '/tooltips',
        name: 'tooltips',
        component: () => import(/* webpackChunkName: "tooltips" */ '@/modules/documentation/pages/tooltips.vue')
    },
    {
        key: 'tags',
        path: '/tags',
        name: 'tags',
        component: () => import(/* webpackChunkName: "tags" */ '@/modules/documentation/pages/tags.vue')
    },
    {
        key: 'message-boxes',
        path: '/message-boxes',
        name: 'message-boxes',
        component: () => import(/* webpackChunkName: "message-boxes" */ '@/modules/documentation/pages/message-boxes.vue')
    },
    {
        key: 'links',
        path: '/links',
        name: 'links',
        component: () => import(/* webpackChunkName: "links" */ '@/modules/documentation/pages/links.vue')
    },
    {
        key: 'loader',
        path: '/loader',
        name: 'loader',
        component: () => import(/* webpackChunkName: "loader" */ '@/modules/documentation/pages/loader.vue')
    },
    {
        key: 'icons',
        path: '/icons',
        name: 'icons',
        component: () => import(/* webpackChunkName: "icons" */ '@/modules/documentation/pages/icons.vue')
    },
    {
        key: 'fonts',
        path: '/fonts',
        name: 'fonts',
        component: () => import(/* webpackChunkName: "fonts" */ '@/modules/documentation/pages/fonts.vue')
    },
    {
        key: 'tables',
        path: '/tables',
        name: 'tables',
        component: () => import(/* webpackChunkName: "tables" */ '@/modules/documentation/pages/tables.vue')
    },
    {
        key: 'modals',
        path: '/modals',
        name: 'modals',
        component: () => import(/* webpackChunkName: "modals" */ '@/modules/documentation/pages/modals.vue')
    },
    {
        key: 'global',
        path: '/global',
        name: 'global',
        component: () => import(/* webpackChunkName: "global" */ '@/modules/documentation/pages/global.vue')
    },
    {
        key: 'responsive',
        path: '/responsive',
        name: 'responsive',
        component: () => import(/* webpackChunkName: "responsive" */ '@/modules/documentation/pages/responsive.vue')
    }
];
